<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="page_ii"></a>This book is dedicated to my friends and colleagues in the Royal Air Force who lost their lives flying in the service of their country, who faced the risks willingly and died doing what they loved, especially:</p>
<table>
<tbody><tr>
<td><p class="ttext"><span class="bold">Dave Hampton</span></p></td>
<td><p class="ttext">7 April 1975</p></td>
<td><p class="ttext">Lightning F.6</p></td>
</tr>
<tr>
<td><p class="ttext"><span class="bold">Chris Jones</span></p></td>
<td><p class="ttext">23 November 1978</p></td>
<td><p class="ttext">F-4 Phantom FG.1</p></td>
</tr>
<tr>
<td><p class="ttext"><span class="bold">Ian Dixon</span></p></td>
<td><p class="ttext">28 October 1983</p></td>
<td><p class="ttext">Tornado GR.1</p></td>
</tr>
<tr>
<td><p class="ttext"><span class="bold">Dave (‘Frosty’) Frost</span></p></td>
<td><p class="ttext">13 July 1984</p></td>
<td><p class="ttext">Lightning F.6</p></td>
</tr>
<tr>
<td><p class="ttext"><span class="bold">Martin (‘Tetley’) Ramsay</span></p></td>
<td><p class="ttext">6 March 1985</p></td>
<td><p class="ttext">Lightning F.6</p></td>
</tr>
<tr>
<td><p class="ttext"><span class="bold">Neil (‘Clachy’) Maclachlan</span></p></td>
<td><p class="ttext">25 January 1988</p></td>
<td><p class="ttext">Red Arrows Hawk T.1</p></td>
</tr>
<tr>
<td><p class="ttext"><span class="bold">Pete (‘Stoney’) Stone</span></p></td>
<td><p class="ttext">20 June 1989</p></td>
<td><p class="ttext">Harrier T.4</p></td>
</tr>
<tr>
<td><p class="ttext"><span class="bold">Steve (‘Alf’) Moir</span></p></td>
<td><p class="ttext">21 July 1989</p></td>
<td><p class="ttext">Tornado F.3</p></td>
</tr>
<tr>
<td><p class="ttext"><span class="bold">Bill Vivian and Des Lacey</span></p></td>
<td><p class="ttext">15 June 1998</p></td>
<td><p class="ttext">Tornado F.3</p></td>
</tr>
</tbody></table>
<p class="ded1">And to those they loved and who loved them, whom they left behind.</p>
<p class="ded2">Also, to my wife, Elaine, who lived with those risks daily and who put up with so much to support me through my long career as an RAF pilot.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Dedication.vue?f92e2388